import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import {
	getFirestore,
	doc,
	getDoc,
	updateDoc,
	collection,
	getDocs,
} from "firebase/firestore";
import {
	getStorage,
	ref as storageRef,
	uploadBytes,
	getDownloadURL,
} from "firebase/storage";
import { useDispatch } from "react-redux";
import {
	setAnnouncement,
	setMenuItems,
	setLoading,
} from "../store/slices/menu";
import { v4 } from "uuid";
import { removeToken } from "../store/slices/user";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ROOT = "haniuuan";
const VERSION = "v2";

export function useFirebase() {
	const db = getFirestore();
	const storage = getStorage();
	const auth = getAuth();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { t } = useTranslation();

	const logout = () => {
		dispatch(removeToken());
		navigate("/login");
	};

	const getFbData = async (key) => {
		dispatch(setLoading(true));
		try {
			// Отримуємо announcement з документа v2
			const docRef = doc(db, ROOT, VERSION);
			const docSnap = await getDoc(docRef);

			if (docSnap.exists()) {
				const data = docSnap.data();
				dispatch(setAnnouncement(data.announcement || ""));
			}

			// Отримуємо items з субколекції
			const itemsRef = collection(db, ROOT, VERSION, "items");
			const itemsSnap = await getDocs(itemsRef);

			let loadedItems = [];
			itemsSnap.forEach((doc) => {
				loadedItems.push({ ...doc.data(), id: doc.id });
			});

			dispatch(setMenuItems(loadedItems));
			dispatch(setLoading(false));
			return true;
		} catch (e) {
			console.error("Load error:", e);
			alert(t("badLoad"));
			dispatch(setLoading(false));
			return false;
		}
	};

	const updateFbAnnouncement = async (data) => {
		try {
			const docRef = doc(db, ROOT, VERSION);
			await updateDoc(docRef, { announcement: data });
			await getFbData();
			console.log("Announcement update success");
		} catch (e) {
			console.log("Announcement update error: ", e);
			logout();
			return false;
		}
	};

	const fbAuth = async ({ email, password }) => {
		try {
			return await signInWithEmailAndPassword(auth, email, password);
		} catch (e) {
			if (
				e.message.indexOf("auth/wrong-password") !== -1 ||
				e.message.indexOf("auth/invalid-email") !== -1 ||
				e.message.indexOf("auth/user-not-found") !== -1
			) {
				return "authError";
			} else {
				return "unknown";
			}
		}
	};

	const updateItem = async ({ index, data }) => {
		try {
			const itemRef = doc(db, ROOT, VERSION, "items", index);
			await updateDoc(itemRef, data);
			await getFbData();
			console.log("Item update success");
		} catch (e) {
			console.log("Item update error ", e);
			logout();
			return false;
		}
	};

	const fbFileUpload = async (image) => {
		if (!image) {
			return;
		}
		const imageRef = storageRef(storage, `${v4() + "-" + image.name}`);
		try {
			const uploadTask = await uploadBytes(imageRef, image);
			return getDownloadURL(uploadTask.ref);
		} catch (e) {
			console.log("Upload error ", e);
			logout();
			return false;
		}
	};

	return {
		getFbData,
		fbAuth,
		updateFbAnnouncement,
		updateItem,
		fbFileUpload,
	};
}
